import { usePageContext } from "@/lib/context/page-context";
import { isTablesPermissionsClientError } from "@/lib/getFriendlyErrorMessage";
import { Sentry } from "@/server/observability/sentry";

export function TablePermissionsErrorBoundary({
  children,
  fallback: Fallback,
}: {
  children: React.ReactNode;
  fallback: () => React.ReactElement;
}) {
  const { isEditing } = usePageContext();

  return (
    <Sentry.ErrorBoundary
      fallback={(errorInfo) => {
        // If we're in the editor and the error is a permissions error, show a
        // special error state to help the builder fix the issue. Otherwise,
        // rethrow the error to let the standard block error state render.
        if (isEditing && isTablesPermissionsClientError(errorInfo.error)) {
          return <Fallback />;
        }

        throw errorInfo.error;
      }}
    >
      {children}
    </Sentry.ErrorBoundary>
  );
}
